export default __webpack_public_path__ + "static/estadioRegional-ce73b26ebd56d10239303c3b10e674e4.jpeg";